import React, { useEffect, useState } from "react";
import useAllowSticky from "../../utils/useAllowSticky";
import styles from "./MetalCloudPg.module.css";
import HeroSection from "./HeroSection/HeroSection";
import TrustedPartners from "./TrustedPartners/TrustedPartners";
import TheReality from "./TheReality/TheReality";
import MetalCloudWay from "./MetalCloudWay/MetalCloudWay";
import RecognizedGlobally from "./RecognizedGlobally/RecognizedGlobally";
import BuiltInIndia from "./BuiltInIndia/BuiltInIndia";
import DiagnosticReport from "./DiagnosticReport/DiagnosticReport";
import Testimonials from "./Testimonials/Testimonials";
import CaseStudy from "./CaseStudy/CaseStudy";
import ConnectWithUsModal from "../../Components/General/ConnectWithUsModal";

const PAGE_TITLE =
  "MetalCloud | Your Entire Shop Floor On One AI Execution System";

const PAGE_DESCRIPTION =
  "MetalCloud is an AI-first execution system for foundries, connecting real-time shopfloor data to deliver verified execution, predictable outcomes, and faster operational decision-making.";

export default function MetalCloudPg() {
  const [modalOpen, setModalOpen] = useState(false);
  const openDemoModal = () => setModalOpen(true);

  // Set directly rather than through <Helmet>: react-helmet-async is mounted in
  // this app but never emits into the head (no data-rh nodes appear), so a
  // Helmet block here would silently do nothing. Header and App skip their own
  // document.title writes for this path — the /metalcloud entry in
  // headerTitleJSON uses a JSX <img> for `text` (the header logo), which
  // stringifies to "[object Object]".
  useEffect(() => {
    document.title = PAGE_TITLE;

    const meta = document.querySelector('meta[name="description"]');
    const previous = meta?.getAttribute("content");
    meta?.setAttribute("content", PAGE_DESCRIPTION);

    return () => {
      if (meta && previous != null) meta.setAttribute("content", previous);
    };
  }, []);

  // THE REALITY and the Solution section pin with `position: sticky`.
  useAllowSticky();

  return (
    <>
      {/* Hero and Trusted Partners share one tinted background with a
          diagonal split — see MetalCloudPg.module.css. */}
      <div className={styles.heroBand}>
        <HeroSection onBookDemo={openDemoModal} />
        <TrustedPartners />
      </div>
      <TheReality />
      <MetalCloudWay />
      <RecognizedGlobally />
      <BuiltInIndia />
      <DiagnosticReport onBookDemo={openDemoModal} />
      <Testimonials />
      <CaseStudy />
      <ConnectWithUsModal modalOpen={modalOpen} setModalOpen={setModalOpen} />
    </>
  );
}
